import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import Swal from 'sweetalert2';
import { OnboardingStatus } from '../data/onboarding-status';

@Component({
  selector: 'app-clever-rostering',
  templateUrl: './clever-rostering.component.html',
  styleUrls: ['./clever-rostering.component.scss']
})
export class CleverRosteringComponent extends BaseComponent implements OnInit {

  orgId: number;
  cleverId: string;
  onboardingStatus: OnboardingStatus;
  waiting: boolean = false;

  ngOnInit() {
    this.route.params.subscribe(params =>
      {
        this.orgId = params.organizationId;
        this.dataService.getOnboardingStatus(this.orgId).subscribe(status => {
          this.onboardingStatus = status;
        });
      });
  }

  submitCleverId() {
    this.waiting = true;
    this.dataService.linkCleverOrganization(this.orgId, this.cleverId).subscribe({
      next: s => {
        Swal.fire('Success', 'Your data from Clever should be synced within 48 hours.', 'success');
        this.waiting = false;
      },
      error: err => {
        Swal.fire('Oops!', '' + err, 'error');
        this.waiting = false;
      }
    });
  }

}
